<template>
    <div class="form">
        <h4 class="step-title">
            In the past 3 years, have you had any accidents or tickets?
        </h4>
        <div class="step-content d-flex flex-column flex-md-row">
            <yes-no-button-list v-bind:onclick="complete"></yes-no-button-list>
        </div>
    </div>
</template>

<script>
    import YesNoButtonList from "./shared/YesNoButtonList.vue"

    export default {
        name: "AccidentsOrTicketsInPast3Years",
        components: {
            YesNoButtonList
        },
        props: {
            lead: Object
        },
        methods: {
          complete: function(accidentsOrTicketsInPast3Years) {
              this.lead.accidentsOrTicketsInPast3Years = accidentsOrTicketsInPast3Years;
              this.$emit("complete", this.$options.name, accidentsOrTicketsInPast3Years);
          }
        }
    }
</script>
